import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityTiposRolState,
  entityTiposRolAdapter
} from './entity-tipos-rol.state';

const { selectEntities, selectAll } = entityTiposRolAdapter.getSelectors();

export const getError = (state: EntityTiposRolState): any => state.error;

export const getIsLoading = (state: EntityTiposRolState): boolean =>
  state.isLoading;

export const selectTiposRolState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tiposRol
);

export const selectAllTiposRol = createSelector(selectTiposRolState, selectAll);
export const selectEntitiesTiposRol = createSelector(
  selectTiposRolState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectTiposRolError = createSelector(
  selectTiposRolState,
  getError
);

// MemoizedSelector<object,any>
export const selectTiposRolIsLoading = createSelector(
  selectTiposRolState,
  getIsLoading
);
